import { useI18n as useI18nEx } from "./Components/I18nProvider";


export const useI18n: AppView.I18nHook = useI18nEx as any;

export { useApp } from "./Components/Provider";
export { useMicroApp, useJourneyData } from "./Components/MicroApp";

export * from "./Core";
export * from "./Components/App";
export * from "./Components/RouterWrapper";
export * from "./Components/ScreenMedia";
export * from "./HOC/withService";
export * from "./HOC/withLoading";
export * from "./Store/Configuration";